import { brandAssets } from '@echo/brand';
import mascotReportGroup from '@echo/brand/assets/mascot-report-group.png';
import { SUPPORT_EMAIL } from '@echo/core';
import { buttonVariants } from '@echo/ui-web';
import { Trans, useLingui } from '@lingui/react/macro';
import { createFileRoute, Link } from '@tanstack/react-router';
import { EmptyStateArt, EmptyStateFrame, ToolbarBack } from '@/components/empty-state-frame';

export const Route = createFileRoute('/_app/groups_/$id_/report')({ component: ReportGroupPage });

/**
 * Figma group/options › Report group: a concern goes to the team by email, so "Email us" opens
 * the mail app on the support address and Cancel returns to the group.
 */
function ReportGroupPage() {
  const { t } = useLingui();
  const { id } = Route.useParams();
  const backLink = ({ className, children }: { className: string; children: React.ReactNode }) => (
    <Link to="/groups/$id" params={{ id }} className={className}>
      {children}
    </Link>
  );
  return (
    <>
      <ToolbarBack render={backLink} />
      <EmptyStateFrame
        art={
          <EmptyStateArt
            src={mascotReportGroup}
            alt={t`A worried brain character holding a red flag`}
            width={brandAssets.mascotReportGroup.width}
            height={brandAssets.mascotReportGroup.height}
          />
        }
        title={<Trans>Report this group</Trans>}
        actions={
          <>
            <Link
              to="/groups/$id"
              params={{ id }}
              className={buttonVariants({ variant: 'tertiary' })}
            >
              <Trans>Cancel</Trans>
            </Link>
            <a href={`mailto:${SUPPORT_EMAIL}`} className={buttonVariants()}>
              <Trans>Email us</Trans>
            </a>
          </>
        }
      >
        <Trans>
          Have a concern about this group? Send us an email with the group's name and a few details
          about your concern. A member of our team will be happy to help.
        </Trans>
      </EmptyStateFrame>
    </>
  );
}
